export default function Tabs() {
    document.querySelectorAll('.b-tabs')
        .forEach(tabs => {
            let first_active = tabs.getAttribute('data-first') - 1,
                cl_tab = tabs.getAttribute('data-tab-active'),
                cl_content = tabs.getAttribute('data-content-active'),
                tabs__items = tabs.querySelectorAll(':scope > .b-tabs__items > .b-tabs__item'),
                tabs__contents = tabs.querySelector(':scope > .b-tabs__content'),
                tab__contents = tabs.querySelectorAll(':scope > .b-tabs__content > .b-tabs__content-item');

            tabs__items.forEach((tab, tkey) => {

                if(first_active >= 0){
                    if(first_active === tkey){
                        tab.classList.add(cl_tab);

                        tab__contents.forEach((content, ckey) => {
                            if (ckey === first_active) {
                                content.classList.add(cl_content);
                            }
                        });
                    }
                }

                tab.addEventListener('click', (e) => {
                    e.preventDefault();

                    console.log(tabs__contents)
                    tabs__contents.scrollIntoView({ behavior: "smooth" });

                    tab.classList.add(cl_tab);
                    tabs__items.forEach((ctab, ctkey) => {
                        if (ctkey !== tkey) {
                            ctab.classList.remove(cl_tab);
                        }
                    });

                    tab__contents.forEach((content, ckey) => {
                        if (ckey === tkey) {
                            content.classList.add(cl_content);
                        } else {
                            content.classList.remove(cl_content);
                        }
                    });

                })
            });
        });
}